var _defs, _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10148IconServiceAnalysisServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6df9393-2bd7-4ac4-ba06-ab5f16ff5923",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd591b35-0e01-4610-a025-8e017443b6ca",
    x1: 3.96,
    y1: 2.52,
    x2: 3.96,
    y2: 7.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bded69e0-afb1-4c25-aa81-a799bd12553b",
    x1: 14.04,
    y1: 5.58,
    x2: 14.04,
    y2: 10.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f25b6c72-365d-4ac2-a15c-1cace994f1e6",
    x1: 5.29,
    y1: 10.18,
    x2: 5.29,
    y2: 15.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-analytics-148") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.52,
    width: 6.92,
    height: 5.31,
    rx: 0.28,
    fill: "url(#fd591b35-0e01-4610-a025-8e017443b6ca)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.58,
    y: 5.58,
    width: 6.92,
    height: 5.31,
    rx: 0.28,
    fill: "url(#bded69e0-afb1-4c25-aa81-a799bd12553b)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.82,
    y: 10.18,
    width: 6.92,
    height: 5.31,
    rx: 0.42,
    fill: "url(#f25b6c72-365d-4ac2-a15c-1cace994f1e6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.15,8.92l.23-.64L4.82,5.13l-.23.63Zm.53-.09-.32-.6L5.29,12.48l.31.6ZM5,13.37l.67-.12L4.31,5.54l-.67.12Z",
    fill: "#773adc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.04,
    cy: 8.23,
    r: 1.08,
    transform: "translate(-2.23 8.81) rotate(-32.41)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.96,
    cy: 5.17,
    r: 1.08,
    transform: "translate(-2.15 2.93) rotate(-32.41)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.29,
    cy: 12.83,
    r: 1.08,
    transform: "translate(-6.05 4.83) rotate(-32.41)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10148IconServiceAnalysisServices);
export default __webpack_public_path__ + "static/media/10148-icon-service-Analysis-Services.c8a77340e5cb7e3d91a19f65a7cb6e56.svg";
export { ForwardRef as ReactComponent };